module.exports = __webpack_public_path__ + "fonts/email_70x70.55bbd21b8856c3b33bb898b13c86fd92.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/email_70x70.png
// module id = 735
// module chunks = 9